var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06Zinkou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F90133;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24,6 20,6 20,16 22,16 22,26 26,26 26,16 28,16 28,6  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "10,6 10,16 12,16 12,26 16,26 16,16 18,16 18,6 14,6  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14,
    cy: 4,
    r: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,6 0,16 2,16 2,26 6,26 6,16 8,16 8,6 4,6  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 4,
    cy: 4,
    r: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_px\\u5358\\u4F4D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_px\\u5358\\u4F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06Zinkou);
export default __webpack_public_path__ + "static/media/06_zinkou.8391419f5f18610f249bead76c8fb624.svg";
export { ForwardRef as ReactComponent };